const PartInformation = {
    QX7: "qx7",
    CUSTOMIZER_BACKEND: "customizer_backend",

    initialize: function(labels, settings) {
        let part_info = [];
        let teamColors = this.colorExtractor(ub.current_material.settings.team_colors);

        _.each(labels, label => {
            let part = {
                part: label.name,
                type: "color",
                // Fabric Information
                fabric: {
                    id: 0,
                    name: "",
                    source: this.CUSTOMIZER_BACKEND
                },
                // Color Information
                color: {
                    id: 0,
                    name: "",
                    source: this.CUSTOMIZER_BACKEND
                },
                // Pattern Information
                pattern: {
                    id: 0,
                    name: "",
                    colors: [],
                    source: this.CUSTOMIZER_BACKEND,
                    color_source: this.CUSTOMIZER_BACKEND
                },

                gradient: {
                    colors: [],
                    source: this.CUSTOMIZER_BACKEND
                },

                // Angle Information
                angle: [],
                // Selection Array
                pattern_selections: [],
                fabric_selections: []
            }

            let materialSettings = this.getSettingByCode(label.fullname);

            if (_.isUndefined(materialSettings)) return;

            let patternSettings = materialSettings.pattern;
            let gradientSettings = materialSettings.gradient;
            let colorObject = materialSettings.colorObj;
            let fabric = this.getFabricInformation();
            let angleData = this.getAngle(label.fullname.toTitleCase());

            // Set angle information
            part.angle = angleData;
            
            // Set Fabric
            if (!_.isUndefined(fabric)) {
                part.fabric.id = +fabric.id;
                part.fabric.name = fabric.material;

                part.fabric_selections.push({
                    fabric_id: +fabric.id,
                    fabric_name: fabric.material
                })
            }

            if (!_.isUndefined(patternSettings) && !_.isUndefined(patternSettings.pattern_obj)) {
                let patternObject = patternSettings.pattern_obj;
                
                if (patternObject.name.toLowerCase() !== "blank") {
                    part.type = "pattern";
                    // Set Pattern 
                    part.pattern.id = +patternObject.pattern_id;
                    part.pattern.name = patternObject.name;

                    let patternColors = [];

                    _.each(patternObject.layers, layer => {
                        if (!_.isUndefined(layer.colorObj)) {
                            patternColors.push(+layer.colorObj.id);
                        }
                    });

                    part.pattern.colors = patternColors;

                    part.pattern_selections.push({
                        pattern_id: +patternObject.pattern_id,
                        pattern_name: patternObject.name
                    })
                }
            }

            if (!_.isUndefined(gradientSettings) && !_.isUndefined(gradientSettings.gradient_obj)) {
                // Set type to gradient
                part.type = "gradient";

                let gradientObject = gradientSettings.gradient_obj;
                
                let gradientColors = [];

                _.each(gradientObject.layers, layer => {
                    if (!_.isUndefined(layer.colorObj)) {
                        gradientColors.push(+layer.colorObj.id);
                    }
                });

                part.gradient.colors = gradientColors;
            }

            if (typeof colorObject !== "undefined") {
                part.color.id = +colorObject.id;
                part.color.name = colorObject.name;

                part.color_selections = this.colorExtractor(label.colors);
            }

            part_info.push(part);
        })

        settings.part_info = {
            team_color: teamColors,
            parts_info: part_info
        }
    },

    getFabricInformation: () => {
        let rch_alias = ub.current_material.settings.current_fabric
        return _.find(ub.current_material.fabrics, {rch_alias})
    },

    colorExtractor: (colorList) => {
        let colors = [];

        _.each(colorList, color => {
            colors.push({
                color_id: +color.id,
                color_name: color.name
            });
        });
        
        return colors;
    },

    getAngle: (name) => {
        let angles = [];
        let materialOptions = _.filter(ub.current_material.materials_options, {name});

        if (_.size(materialOptions) > 0) {
            _.each(materialOptions, option => {
                let angle = option.angle ?? 0
                angles.push({
                    default: angle,
                    translateAngle: ub.funcs.translateAngle(angle),
                    perspective: option.perspective
                })
            })
        }

        return angles;
    },

    patternExtractor: (patternList) => {
        let patterns = [];

        _.each(patternList, pattern => {
            patterns.push({
                pattern_id: +pattern.id,
                pattern_name: pattern.name
            });
        });

        return patterns
    },

    getSettingByCode: (materialOptionCode) => {
        let type =  ub.current_material.material.type,
            uniformSettings = ub.current_material.settings[type];
        
        return _.find(uniformSettings, {code: materialOptionCode});
    }
}